import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { appConfigAPI } from '@/providers/apis/app/app-config';
import { appConfigService } from '@/providers/services/app/app-config';

@Component({
    name: 'dashboard',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class Dashboard extends Vue {
    // ---------------------------------------------------------------------
    // Properties

    public getUsageReport() {
        this.$router.push('/usage-report');
    }
    public getCoverageReport() {
        this.$router.push('/coverage');
    }
    public getUsageContent() {
        this.$router.push('/usage-content');

    }
    public getThresholdContent() {
        this.$router.push('/threshold');
    }
    public getDiscover() {
        this.$router.push('/discover');
    }
}
